import * as React from "react";
const SvgFiRrDepositAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-deposit-alt_svg__a)">
      <path
        fill="#062147"
        d="M8.293 4.121a.999.999 0 1 1 1.414-1.414L11 4V1a1 1 0 0 1 2 0v3l1.293-1.293a.999.999 0 1 1 1.414 1.414l-2.293 2.293c-.39.39-.902.585-1.414.585a2 2 0 0 1-1.414-.585zM11 11v1c-1.654 0-3 1.346-3 3 0 1.36.974 2.51 2.315 2.733l3.042.507a.77.77 0 0 1 .644.76c0 .551-.448 1-1 1h-2.268c-.356 0-.688-.192-.867-.5a1 1 0 1 0-1.73 1.001A3.01 3.01 0 0 0 10.732 22h.268v1a1 1 0 0 0 2 0v-1c1.654 0 3-1.346 3-3 0-1.36-.974-2.51-2.315-2.733l-3.04-.507A.77.77 0 0 1 10 15c0-.551.45-1 1-1h2.268c.356 0 .688.192.867.5a.998.998 0 1 0 1.73-1.001 3.01 3.01 0 0 0-2.598-1.5H13v-1a1 1 0 0 0-2 0zm12 11h-2V10h.292c1.023 0 1.95-.555 2.417-1.448a2.44 2.44 0 0 0-.153-2.566 4.7 4.7 0 0 0-1.668-1.498l-2.64-1.375a1 1 0 1 0-.924 1.774l2.64 1.376a2.7 2.7 0 0 1 .95.864.45.45 0 0 1 .022.499.72.72 0 0 1-.645.375H2.708a.72.72 0 0 1-.646-.375.45.45 0 0 1 .023-.498c.265-.38.593-.679.95-.865l2.641-1.375a1 1 0 1 0-.924-1.774l-2.64 1.375A4.7 4.7 0 0 0 .442 5.987 2.44 2.44 0 0 0 .29 8.552 2.71 2.71 0 0 0 2.708 10H3v12H1a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H5V10h14v12h-2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-deposit-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDepositAlt;
